var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarousel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 231,
    viewBox: "0 0 320 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_779_2282)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319.846,
    height: 231,
    rx: 8.88462,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.346,
    y: 17.6614,
    width: 104.838,
    height: 8.88461,
    rx: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6621,
    y: 109.731,
    width: 79.9615,
    height: 8.88461,
    rx: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6621,
    y: 123.946,
    width: 44.4231,
    height: 8.88461,
    rx: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4316,
    y: 208.789,
    width: 44.4231,
    height: 8.88461,
    rx: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.205,
    y: 34.646,
    width: 27.5423,
    height: 8.88461,
    rx: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.743,
    cy: 39.0883,
    r: 4.44231,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.051,
    y: 88.8457,
    width: 53.3077,
    height: 62.1923,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_779_2282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.035 127.05H148.214C148.002 127.049 147.793 126.998 147.604 126.901C147.415 126.804 147.253 126.663 147.13 126.49C147.003 126.317 146.92 126.116 146.889 125.903C146.858 125.691 146.879 125.474 146.952 125.273L150.044 116.317C150.14 116.05 150.318 115.82 150.552 115.66C150.787 115.5 151.066 115.419 151.35 115.428C151.632 115.432 151.905 115.528 152.128 115.701C152.351 115.874 152.512 116.115 152.585 116.388L154.175 122.287C154.198 122.38 154.251 122.463 154.327 122.521C154.403 122.58 154.497 122.61 154.593 122.607C154.689 122.612 154.783 122.585 154.862 122.53C154.941 122.475 154.999 122.396 155.028 122.305L155.917 119.64C156.004 119.373 156.174 119.141 156.401 118.976C156.629 118.812 156.902 118.723 157.183 118.723C157.463 118.723 157.737 118.812 157.964 118.976C158.192 119.141 158.361 119.373 158.449 119.64L160.323 125.273C160.396 125.476 160.417 125.694 160.386 125.908C160.355 126.122 160.273 126.325 160.146 126.499C160.019 126.674 159.852 126.816 159.658 126.911C159.465 127.007 159.251 127.055 159.035 127.05V127.05ZM151.306 116.308C151.211 116.304 151.118 116.331 151.041 116.386C150.963 116.441 150.907 116.52 150.879 116.61L147.787 125.575C147.765 125.641 147.758 125.713 147.769 125.782C147.78 125.852 147.808 125.918 147.849 125.974C147.89 126.033 147.945 126.081 148.008 126.113C148.072 126.146 148.142 126.162 148.214 126.161H159.035C159.105 126.161 159.174 126.144 159.236 126.111C159.298 126.079 159.351 126.032 159.391 125.974C159.433 125.918 159.461 125.852 159.472 125.782C159.483 125.713 159.476 125.641 159.453 125.575L157.605 119.942C157.605 119.824 157.558 119.711 157.475 119.628C157.391 119.544 157.278 119.498 157.161 119.498C157.043 119.498 156.93 119.544 156.846 119.628C156.763 119.711 156.716 119.824 156.716 119.942L155.828 122.607C155.736 122.878 155.56 123.113 155.325 123.276C155.09 123.439 154.809 123.522 154.523 123.513C154.237 123.504 153.962 123.404 153.738 123.226C153.513 123.049 153.352 122.803 153.278 122.527L151.732 116.637C151.71 116.543 151.657 116.459 151.581 116.399C151.505 116.34 151.411 116.307 151.314 116.308H151.306Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.954 116.833C156.559 116.833 156.172 116.715 155.844 116.496C155.515 116.276 155.259 115.964 155.107 115.599C154.956 115.233 154.916 114.831 154.993 114.444C155.071 114.056 155.261 113.7 155.541 113.42C155.82 113.14 156.176 112.95 156.564 112.873C156.952 112.796 157.354 112.835 157.719 112.987C158.084 113.138 158.397 113.394 158.616 113.723C158.836 114.052 158.953 114.438 158.953 114.834C158.953 115.364 158.743 115.872 158.368 116.247C157.993 116.622 157.484 116.833 156.954 116.833V116.833ZM156.954 113.723C156.734 113.723 156.52 113.788 156.337 113.91C156.154 114.032 156.012 114.206 155.928 114.409C155.844 114.611 155.822 114.835 155.865 115.05C155.908 115.266 156.014 115.463 156.169 115.619C156.324 115.774 156.522 115.88 156.737 115.923C156.953 115.966 157.176 115.944 157.379 115.86C157.582 115.775 157.755 115.633 157.878 115.451C158 115.268 158.065 115.053 158.065 114.834C158.065 114.539 157.948 114.256 157.739 114.048C157.531 113.84 157.249 113.723 156.954 113.723V113.723Z",
    fill: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 127.051,
    y: 100.846,
    width: 53.3077,
    height: 62.1923,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 89,
    width: 53,
    height: 74,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 89,
    width: 54,
    height: 74,
    rx: 3.55385,
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 89,
    width: 53,
    height: 74,
    rx: 3.55385,
    fill: "#DBDBDB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.444231,
    y: 0.444231,
    width: 318.958,
    height: 230.112,
    rx: 8.44038,
    stroke: "#DBDBDB",
    strokeWidth: 0.888462
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_779_2282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319.846,
    height: 231,
    rx: 8.88462,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_779_2282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2154,
    height: 14.2154,
    fill: "white",
    transform: "translate(146.596 112.834)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarousel);
export default __webpack_public_path__ + "static/media/carousel.cd1ce2714bd4a58c0caab65bb8d35f76.svg";
export { ForwardRef as ReactComponent };